<template>
  <div>
    <div class="upBody" v-if="show">
      <div class="goodsCar-up">
        <div class="goodsCar-up-title">
          <span></span>
          加入购物车
          <img :src="'icon_close.png' | imagePath" class="pointer" @click="hide"/>
        </div>
        <div class="goodsCar-up-body">
          <div class="goodsCar-up-body-goods">
            <el-image :src="thumbnail" fit="cover" class="goodsCar-up-body-goods-picture">
              <div slot="error" class="image-slot">
                <el-image :src="'replaceImg.jpg' | imagePath"></el-image>
              </div>
            </el-image>
            <div class="goodsCar-up-body-goods-info">
              <div class="goodsCar-up-body-goods-name twoLine">{{title}}</div>
              <div class="goodsCar-up-input">
                <div class="goodsCar-up-body-goods-price">￥{{ (price_type == 1 ? price : agreement_price) | productPrice(priceFormatEnabled) }}</div>
                <div class="goodsCar-up-body-goods-stock">可售库存：<span style="color:red;font-weight:bold">{{ stock > 0 ? '有货' : '无货' }}</span></div>
                <div class="goodsCar-up-body-num">
                  <el-input-number v-model="num"  size="mini" :min="1" :max="stock"></el-input-number>
                </div>
              </div>
            </div>
          </div>
          <div class="goodsCar-up-body-spec">
            <div class="goodsCar-up-body-spec-item" v-for="(item,index) in goods_specs" :key="index">
              <span class="goodsCar-up-body-spec-item-label">{{item.spec_name}}</span>
              <ul class="goodsCar-up-body-spec-item-list">
                <li v-for="(val,cindex) in item.items"
                  :key="cindex"
                  :class="{'active':item.specIndex==cindex}"
                  @click="specClick(item,cindex)"
                  class="pointer">
                  {{val.item_value}}
                </li>
              </ul>
            </div>
          </div>

        </div>
        <button :disabled="!canOrder" class="goodsCar-up-btn" @click="addToCar">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      goods_id:[String,Number],
      show:Boolean,
      priceFormatEnabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        goods_specs:[],
        num:1,
        thumbnail:'',
        title:'',
        price:'',
        agreement_price:'',//协议价格
        price_type:0,//1普通商品 取price 2活动商品 3协议商品 取agreement_price
        spec_prices:[],
        spec_prices_sift:[],
        specSelectId:'',//选中规格拼接id
        stock: 0,//库存
      }
    },
    computed:{
      canOrder(){
        return this.stock > 0
      }
    },
    watch:{
      goods_id(id){
        if (id == 0) return;
        this.$.http.post('goods/detail',{goods_id:id}).then(res=>{
          res = res.data.goods
          this.thumbnail = res.thumbnail
          this.title = res.title
          this.price = res.price
          this.price_type = res.price_type
          this.agreement_price = res.agreement_price
        })
        this.$.http.post('goods/goodsSpecs',{goods_id:id}).then(res=>{
          res = res.data
           var key_id = []
           res.goods_specs.forEach((item,index)=>{
             item.specIndex = 0
             key_id = key_id.concat(item.items[0].item_key)
           })
          this.goods_specs = res.goods_specs
          this.spec_prices = res.spec_prices
          this.spec_prices_sift = this.spec_prices.filter(item=>item['key'] == key_id.join('-'));
          this.specSelectId = this.spec_prices_sift[0].item_id
          this.price = this.spec_prices_sift[0].price
          this.price_type = this.spec_prices_sift[0].price_type
          this.agreement_price = this.spec_prices_sift[0].agreement_price
          this.stock = this.spec_prices_sift[0].storage
          this.num = 1
        })
      }
    },
    methods:{
      hide(){
        this.$emit('hide')
      },
      //选择规格
      specClick(item,cindex) {
        item.specIndex = cindex
        var key_id = []
        this.goods_specs.forEach((val,index)=>{
          key_id = key_id.concat(val.items[val.specIndex].item_key)
          console.info(key_id)
        })
        console.info(key_id)
        this.spec_prices_sift = this.spec_prices.filter(item=>item['key'] == key_id.join('-'));
        this.specSelectId = this.spec_prices_sift[0].item_id
        this.price = this.spec_prices_sift[0].price
        this.price_type = this.spec_prices_sift[0].price_type
        this.agreement_price = this.spec_prices_sift[0].agreement_price
        this.stock = this.spec_prices_sift[0].storage
        this.num = 1
      },
      // 加入购物车
      addToCar(){
        const { num,specSelectId } = this
        if(specSelectId == ''){
          this.$message.warning('请按需求选择规格')
          return false
        }
        this.$store.dispatch("cart/AddCart", {
          item_id:specSelectId,num ,
        }).then(res=>{
          if(res.code == 200){
            this.num = 1
            this.$message.success(res.message)
            this.hide()
          }
        })
      }
    },
    mounted() {

    }
  }
</script>

<style>

 /* 加入购物车弹框 */
.goodsCar-up{
  width: 540px;
  max-height: 650px;
  padding: 0 30px;
  border-radius: 10px;
  background-color: #FFFFFF;
  max-height: 90%;
  overflow-y: auto;
}
.goodsCar-up-title{
  display: flex;
  justify-content: space-between;
  margin: 30px 0;
  font-size: 20px;
}
.goodsCar-up-title img{
  width: 15px;
  height: 16px;
}
.goodsCar-up-body-goods{
  display: flex;
  align-items: center;
}
.goodsCar-up-body-goods-picture{
  width: 80px;
  height: 80px;
  border-radius: 8px;
  margin-right: 20px;
  flex-shrink: 0;
}

.goodsCar-up-body-goods-name{
  font-size: 16px;
  margin-bottom: 20px;
}
.goodsCar-up-body-goods-price{
  color: #E60012;
  font-size: 16px;
  font-weight: bold;
}
.goodsCar-up-body-spec{
  margin-top: 20px;
}
.goodsCar-up-body-spec-item{
  margin-bottom: 10px;
}
.goodsCar-up-body-spec-item-label{
  display: block;
  font-size: 14px;
  line-height: 30px;
}
.goodsCar-up-body-spec-item-list{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.goodsCar-up-body-spec-item-list li{
  margin-bottom: 10px;
  margin-right: 10px;
  padding: 5px 20px;
  border-radius: 16px;
  border: 1px solid #DDDDDD;
}
.goodsCar-up-body-spec-item-list li.active{
  background-color: #E60012;
   border: 1px solid #E60012;
   color: #FFFFFF;
}
.goodsCar-up-body-num{
  display: flex;
  border-radius: 13px;
  height: 26px;
}

.goodsCar-up-btn{
  display: block;
  width: 140px;
  height: 40px;
  border-radius: 10px;
  background-color: #E60012;
  color: #FFFFFF;
  font-size: 16px;
  margin: 30px auto;
}

.goodsCar-up-input{
  display:flex;
  justify-content:space-between;
  align-items:center
}
.goodsCar-up-body-goods-info{
  flex:1
}
.goodsCar-up-btn[disabled]{
  background-color: #DDDDDD;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/CarUp/index.vue